<template>
    <a-modal
        :visible="visible"
        :title="$t('trace_detail_title')"
        @cancel="handleClose"
        :footer="null"
        width="800px"
    >
        <div class="trace-detail-container">
            <a-timeline>
                <a-timeline-item 
                    v-for="(trace, index) in traceData" 
                    :key="index"
                >
                    <div class="trace-item">
                        <div class="trace-header">
                            <span class="trace-type">{{ trace.TypeName }}</span>
                            <span class="trace-date">{{ formatDate(trace.RecordDate) }}</span>
                        </div>
                        <div class="trace-content">
                            <p v-if="trace.CompanyName">法人名: {{ trace.CompanyName }}</p>
                            <p v-if="trace.CustName">合作方: {{ trace.CustName }}</p>
                            <p v-if="trace.OrderNo">订单号: {{ trace.OrderNo }}</p>
                            <p v-if="trace.OutWHName">出库仓库: {{ trace.OutWHName }}</p>
                            <p v-if="trace.InWHName">入库仓库: {{ trace.InWHName }}</p>
                        </div>
                    </div>
                </a-timeline-item>
            </a-timeline>
        </div>
    </a-modal>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'TraceDetailModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        traceData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            return dayjs(dateString, 'YYYYMMDD').format('YYYY-MM-DD');
        }
    }
}
</script>

<style lang="scss" scoped>
.trace-detail-container {
    max-height: 600px;
    overflow-y: auto;
    padding: 20px;

    .trace-item {
        margin-bottom: 15px;

        .trace-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;

            .trace-type {
                font-weight: bold;
            }

            .trace-date {
                color: #666;
            }
        }

        .trace-content {
            p {
                margin: 4px 0;
            }
        }
    }
}
</style> 